import {
    GET_LOCATION_DATA, GET_LOCATION_DATA_SUCCESS, GET_LOCATION_DATA_FAIL,
} from '../Type';
import { takeLatest, put } from 'redux-saga/effects';
import {
    getLocatonData as getLocatonDataApi
} from '../../Api';

function* getLocatonData(payload){
    try {
        const result = yield getLocatonDataApi(payload.city)
        if (result) {
            yield put({ type: GET_LOCATION_DATA_SUCCESS, data: result })
        } else {
            yield put({ type: GET_LOCATION_DATA_FAIL, data: [] })
        }
    } catch (err) {
        yield put({ type: GET_LOCATION_DATA_FAIL, data: [] })
    }
}

export function* watchGetLocatonData(){
    yield takeLatest(GET_LOCATION_DATA, getLocatonData)
}